module.exports = __webpack_public_path__ + "static/media/category-3.6128805f.png";